<template>
    <div>
        <section class="message-list">
        <v-container>

            <h2 class="section-subtitle">Zprávy</h2>

            <v-divider vertical></v-divider>

            <v-card v-if="loading">
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <v-list v-else two-line class="transparent">
                <template v-for="(item, index) in threads">
                    <v-list-item
                        :key="item.id"
                        :to="{ name: 'messagesDetail', params: { id: item.id } }"
                    >
                        <v-list-item-avatar>
                            <message-avatar :size="48" :type="item.type" :text="item.thread_name"></message-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.thread_name }}
                                <span class="float-right green-text" v-if="item.added !== null">
                                    {{ item.added.date | formatToday }}
                                </span>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <strong v-if="item.nickname">{{ item.nickname }}</strong><span v-if="item.content">&nbsp;&mdash;&nbsp;{{ item.content }}</span>
                                <span v-else>Zatím tu nic není. Buďte první kdo napíše zprávu.</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>

                    </v-list-item>
                    <v-divider
                        v-if="index + 1 < threads.length"
                        :key="index"
                    ></v-divider>
                </template>
            </v-list>

        </v-container>
        </section>
    </div>
</template>

<script>
    import { MESSAGE_LIST_REQUEST } from '../store/actions/message'
    import MessageAvatar from '../components/Message/MessageAvatar';

    export default {
        components: {
            MessageAvatar,
        },
        data () {
            return {
                threads: [],
                loading: false,
            };
        },
        async created () {
            this.loading = true;
            try {
                this.threads = await this.$store.dispatch('message/' + MESSAGE_LIST_REQUEST);
            } catch (e) {
            } finally {
                this.loading = false;
            }
        },
    }
</script>
